import axiosClient from "@/libs/axiosClient";

export const getEsData = options => {
    return axiosClient.post(`/table/${options.esIndex}/search`, options);
};

export const _updateData = (esIndex, action, formData) => {
    return axiosClient.post(`/table/${esIndex}/update/${action}`, formData);
};

export const _batchUpdateData = (esIndex, formData, selectedItems) => {
    return axiosClient.post(`/table/${esIndex}/update/batch`, {
        formData: formData,
        selectedItems: selectedItems
    });
};
export const _batchDeleteData = (esIndex, formData, selectedItems) => {
    return axiosClient.post(`/table/${esIndex}/update/batch-delete`, {
        formData: formData,
        selectedItems: selectedItems
    });
};
export const updateDescription = (params, id, updateData) => {
    return axiosClient.patch(`/general/${params}/${id}`, updateData);
};



// WEBPACK FOOTER //
// ./src/api/esdata.js